module.exports = __webpack_public_path__ + "static/media/cas_email.b2e52f4d.png";